<template lang="pug">
.Popup(
  v-if='show',
  :data-theme='theme'
)
  .Popup-wrapper
    //.Popup-backdrop
    .Popup-window(
      ref='popup',
      :key='component.name',
      :style='{ width: params.width, "max-width": params.width, height: params.height }'
    )
      //
        <div class="Popup-close">
        <button @click='cancel()'>X</button>
        </div>
      .Popup-content(:class='{ "Popup-content--dark": settings && settings.isDark }')
        component(
          :is='component',
          v-bind='params'
        )
    helper-panel(
      v-if='helperType',
      :type='helperType'
    )
</template>

<script>
import HelperPanel from '@/components/HelperPanel'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'popup',

  mixins: [helpertext],

  components: {
    HelperPanel
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    component: Object,
    params: Object,
    settings: Object,
    allowCloseOnEscape: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    theme() {
      return this.$store.getters.theme
    },
    helperType() {
      return this.$store.getters.helperType
    }
  },

  mounted() {
    window.addEventListener('keydown', this.onEscape)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onEscape)
  },

  methods: {
    hide() {
      this.helperText = null
      this.$ui.popup.hide()
    },
    onEscape(e) {
      if (e.keyCode === 27 && this.show && this.allowCloseOnEscape) {
        this.cancel()
      }
    },
    ok(data) {
      this.helperText = null
      this.$ui.popup.ok(data)
    },
    cancel(data = { action: 'close' }) {
      this.helperText = null
      this.$ui.popup.cancel(data)
    }
  }
}
</script>

<style lang="scss">
@import '~base';

.Popup {
  --contentBg: #{$white2};
  --darkContentBg: #{$white2};
  --popupCloseIcon: #{$black5};
}

.Popup[data-theme='dark'] {
  --contentBg: #{$black3};
  --darkContentBg: #{$black1};
  --popupCloseIcon: #{$grey2};
}
</style>
<style lang="scss">
@import '~base';
.Popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  overflow: auto;
  z-index: 15000;

  &:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #000;
    opacity: 0.5;
    cursor: pointer;
  }

  &-wrapper {
    display: flex;
    position: relative;
    min-height: 100%;
    height: 100%;
  }

  /*&-backdrop {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #000;
      opacity: 0.5;
      cursor: pointer;
    }*/

  &-window {
    position: relative;
    margin: auto;
    width: 95%;
    max-width: 548px;
    background: var(--appBg);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  &-close {
    position: absolute;
    top: 5px;
    right: 5px;
    color: var(--popupCloseIcon);
  }

  &-content {
    height: 100%;
    background: var(--contentBg);
    color: var(--basicText);

    &--dark {
      background: var(--darkContentBg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Popup.vue